// extracted by mini-css-extract-plugin
export default {"satisSozlesmesi":"returnpolicy_satisSozlesmesi__AWrLW"};